import * as React from "react";
import { Box, Typography } from "@mui/material";

type Props = {
  onProfile: () => void;
  onHeartsPurchase: () => void;
  onMessages: () => void;
  unreadCount?: number;
};

export default function QuickActions({ onProfile, onHeartsPurchase, onMessages, unreadCount }: Props) {
  const actions = [
    {
      emoji: '👤',
      label: '프로필',
      onClick: onProfile,
    },
    {
      emoji: '💌',
      label: '메시지',
      onClick: onMessages,
      badge: unreadCount,
    },
    {
      emoji: '🤍',
      label: '충전',
      onClick: onHeartsPurchase,
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {actions.map((action, index) => (
        <Box
          key={index}
          component="button"
          onClick={action.onClick}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            py: 2,
            px: 1,
            cursor: 'pointer',
            border: 'none',
            bgcolor: 'white',
            borderRight: index < actions.length - 1 ? '1px solid #E2E8F0' : 'none',
            minHeight: 52,
            transition: 'background 0.15s',
            '&:hover': { bgcolor: '#F8F9FC' },
          }}
        >
          <Box sx={{ position: 'relative', fontSize: '20px', lineHeight: 1 }}>
            {action.emoji}
            {action.badge ? (
              <Box
                sx={{
                  position: 'absolute',
                  top: -3,
                  right: -8,
                  bgcolor: '#B87D8F',
                  color: 'white',
                  borderRadius: '10px',
                  fontSize: '9px',
                  fontWeight: 700,
                  px: '5px',
                  py: '1px',
                  lineHeight: 1.4,
                }}
              >
                {action.badge}
              </Box>
            ) : null}
          </Box>
          <Typography
            sx={{
              fontSize: '11px',
              fontWeight: 600,
              color: '#8896AB',
              letterSpacing: '0.3px',
              lineHeight: 1,
            }}
          >
            {action.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
